var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PeekPortrait',{staticClass:"position-absolute",staticStyle:{"left":"42px","bottom":"42px","z-index":"10000000","transform":"rotate(-2.2deg)"},attrs:{"photo":require('@/assets/image.png'),"size":200}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }